import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, Breadcrumbs, CircularProgress } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import { useStyles } from './styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import PrintIcon from '@material-ui/icons/Print';
import { Link } from 'react-router-dom';
import pdf_icon from '../../assets/pdf_icon.svg';
import { getContent } from '../../actions';
import { scrollTop, renderDefaultMsg } from '../../helpers';
import MailIcon from '@material-ui/icons/Mail';
import { Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { getPdf } from '../../actions';
import { useHistory, useLocation } from 'react-router-dom';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { encrypt, decrypt } from '../../helpers/encrypt';
import './style.css'
import Paper from '@material-ui/core/Paper';
export const Lossmitigation = (props) => {

  const classes = useStyles();
  const [content, setContent] = useState([])
  const [task, settask] = useState([]);
  const [downoadLoader, setDownoadLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const mytheme = useSelector(state => state.theme);
  const { primaryColorCode, secondaryColorCode } = mytheme;

  const dispatch = useDispatch()
  const history = useHistory();
  const selectedAccount = useSelector(state => state.selectedAccount);

  const getContentData = async () => {
    setDownoadLoader(true);
    const obj = {
      isSubmit: props.isSubmit,
      selectedAccount: selectedAccount
    }
    const response = await getPdf(obj);
    if (response) {
      setDownoadLoader(false);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', decrypt(selectedAccount) + '_LMA.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
    else {
      setDownoadLoader(false);
      setErrorMessage(renderDefaultMsg('400'))
    }
  };

  const handleButton = async () => {
    let { from } = { from: { pathname: "/HardshipOptions" } };
    history.replace(from);
  }

  useEffect(() => {
    settask(props.yourTask)
    scrollTop()
  }, [selectedAccount]);


  return (
    <Box className={classes.mainContainer} style={{ background: '#E8E8E8' }}>
      <Box my={1} mx={2} className={classes.formContainer}>
        <Grid container row spacing={4}>
          <Grid item xs={12} sm={9} md={9}>
            <div>
              <Typography className={classes.lossmitigation}>Loss Mitigation Application</Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <div>
              <Typography className={classes.submitby}>Submit Date:</Typography>


              {props.yourTask.isSubmit && <Typography className={classes.datee}>
                {props.yourTask.submitDate}
              </Typography>}
            </div>
          </Grid>
          <div className={classes.divider_1}></div>

          {!props.yourTask.isSubmit && <Grid item xs={12} sm={9} md={9} style={{ marginTop: '20px' }}>
            <div>
              <Box style={{ width: '100%' }}>
                <div className={`${classes.reviewloop} ${classes.scale}`} style={{ padding: '0px' }}>
                  <div className={classes.refresh}>
                    <AutorenewIcon style={{ width: '20px', color: '#535D6D', height: '20px', textAlign: 'center' }} />
                  </div>
                  <div className={`${classes.dataa} ${classes.fixx}`} style={{ marginLeft: '0px' }}>
                    <Typography className={classes.secincomp}>Section Incomplete</Typography>
                  </div>
                </div>
                {/* {props.incomplete.length > 0 && props.incomplete[0].map((item) => {
                  return <Typography key={item.secName} className={classes.bankruptcy}>
                    {item.secName}
                  </Typography>
                })} */}
                {props.incomplete.length > 0 && props.incomplete[0] && <Typography className={classes.bankruptcy}>
                  {props.incomplete[0].secName}
                </Typography>}
              </Box>
            </div>
          </Grid>}
          {!props.yourTask.isSubmit && <Grid item xs={12} sm={3} md={3} className={classes.butarea}>
            <div>
              <Button variant="contained" onClick={handleButton} className={classes.downloadd} color="secondary">
                OPEN IN FORM
            </Button>
            </div>
          </Grid>}
          {!props.yourTask.isSubmit && <div className={classes.divider_1}></div>}

          <Grid item xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
            <div>
              <Box style={{ width: '100%' }}>
                <div className={classes.reviewloop} style={{ padding: '0px' }}>
                  <div className={classes.refresh}>
                    <FindInPageIcon style={{ width: '20px', color: '#535D6D', height: '20px', textAlign: 'center' }} />
                  </div>
                  <div className={classes.dataa} style={{ marginLeft: '0px' }}>
                    <Typography className={classes.secincomp}>Document Required</Typography>
                  </div>
                </div>
                <table className={classes.bankruptcy_1} style={{ maxWidth: '100%', border: '1px solid #000', borderCollapse: 'collapse' }}>
                  {props.document.length > 0 && props.document.map((item) => (
                    <tr style={{ border: '1px solid #000', borderCollapse: 'collapse' }} key={item.optionName}>
                      <td style={{ border: '1px solid #000', padding: '10px', borderCollapse: 'collapse' }}>{item.optionName}</td>
                      <td style={{ border: '1px solid #000', padding: '10px', borderCollapse: 'collapse' }}>{item.documentName}</td>
                    </tr>
                  ))}
                </table>
              </Box>
            </div>
          </Grid>

          <div className={classes.divider_1}></div>

          <Grid item xs={12} sm={9} md={9} style={{ marginTop: '20px' }}>
            <div>

              <Box style={{ width: '100%' }}>
                <div className={classes.reviewloop} style={{ padding: '0px' }}>

                  <div className={classes.refresh_1}>
                    <img className={classes.refresh_img} src={pdf_icon} />
                  </div>
                  <div className={`${classes.dataa} ${classes.adjust}`} style={{ marginLeft: '0px' }}>
                    <div className={classes.topbottom}>
                      <Typography className={classes.pdffile}>File Format: PDF</Typography>
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </Grid>
          <Grid item xs={12} sm={3} md={3} className={classes.butarea}>
            {errorMessage !== '' ? (<p className={classes.errorMsg}> {errorMessage}</p>) : null}
            <div>
              <Button variant="contained" className={classes.downloadd} color="secondary" onClick={getContentData}>
                {!downoadLoader ? 'Download' : <CircularProgress color='primary' style={{ width: 25, height: 25 }} />}
              </Button>
            </div>
          </Grid>
          <div className={classes.divider_1}></div>
          <Grid item xs={12}><Typography className={classes.pdf}>You can send the form to us at:</Typography></Grid>

          <Grid item xs={12} sm={4} md={4} style={{ marginTop: '0px' }}>
            <div>

              <Box style={{ width: '100%' }}>
                <div className={classes.reviewloop} style={{ padding: '0px' }}>

                  <div className={classes.refresh}>
                    <LocationOnIcon style={{ width: '20px', color: '#535D6D', height: '20px', textAlign: 'center' }} />
                  </div>
                  <div className={classes.dataa} style={{ marginLeft: '10px' }}>

                    <Typography className={classes.secincomp}>BSI Financial Services
                  P.O. Box 517 Titusville, PA 16354-0517</Typography>


                  </div>
                </div>


              </Box>
            </div>
          </Grid>
          <Grid item xs={12} sm={8} md={8} style={{ marginTop: '0px' }}>
            <div>

              <Box style={{ width: '100%' }}>
                {props.yourTask.isSubmit && <div className={classes.reviewloop} style={{ padding: '0px' }}>

                  <div className={classes.refresh}>
                    <MailIcon style={{ width: '20px', color: '#535D6D', height: '20px', textAlign: 'center' }} />
                  </div>
                  <div className={classes.dataa} style={{ marginLeft: '10px' }}>

                    <Typography className={classes.secincomp}>Mail us at <b>customer@bsifinancial.com</b></Typography>


                  </div>
                </div>}


              </Box>
            </div>
          </Grid>



        </Grid>
      </Box>
    </Box>
  )
}